import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import './VerifyEmail.scss';

export class VerifyEmail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorState: false
		};
	}

	backTo = () => {
		// Redirect to login page since unverified users can't access /home
		// After email verification, they can log in normally
		this.props.history.push("/login");
	};

	render() {
		return (

			<div className="VerifyContainer">

				<div>
					<div className="info">Almost there, please check your email to verify your account.  Once verified, you will be returned to the portal.
					</div>
					<div><b>Questions?</b> Contact <a href={`mailto:support@metabolon.com?subject=Email Verification`}>support</a> or <a data-testid="verifyemail-back" onClick={this.backTo}>return to login</a>.</div>
				</div>

			</div>
		);
	}
}

export default withRouter(VerifyEmail);